import { OPERATORS, EVAL_VALUES } from 'components/utils'
import {
  DIGITAL_INPUT,
  NATIVE_INPUT,
  SWITCH_INPUT,
  ANALOG_INPUT,
  CAN_INPUT,
  ACTIVE_HIGH,
} from 'utils/constants'
import strings from 'utils/strings'

const DEFAULT_NUM_BITS_INPUT_TO_16_BIT_CAN_OUTPUT = 4
const DEFAULT_SINGLE_NUM_BITS = 2
const DEFAULT_SUB_CONDITION_NUM_BITS = 1
const DEFAULT_VALUE = 0
const DEFAULT_SCALING_INPUT_NUM_BITS = 4
const DEFAULT_NUM_BITS_INPUT_TO_NON_BOOL_NATIVE_OUPUT = 4

export const DEFAULT_NUM_BITS = {
  SINGLE_CONDITION: DEFAULT_SINGLE_NUM_BITS,
  CONDITION_16BIT_OUTPUT: DEFAULT_NUM_BITS_INPUT_TO_16_BIT_CAN_OUTPUT,
  SUB_CONDITION: DEFAULT_SUB_CONDITION_NUM_BITS,
  NATIVE_OUTPUT_CAN_INPUT: DEFAULT_NUM_BITS_INPUT_TO_NON_BOOL_NATIVE_OUPUT,
  SCALING_INPUT: DEFAULT_SCALING_INPUT_NUM_BITS,
}

export const CAN_SIXTEEN_DEFAULTS = {
  numberOfBits: DEFAULT_NUM_BITS_INPUT_TO_16_BIT_CAN_OUTPUT,
  subType: CAN_INPUT,
  description: CAN_INPUT,
}

export const CAN_SINGLE_DEFAULTS = {
  numberOfBits: DEFAULT_NUM_BITS.SINGLE_CONDITION,
  operator: OPERATORS.EQUAL,
  value: DEFAULT_VALUE,
  parentQueryUri: '',
  subType: CAN_INPUT,
  description: CAN_INPUT,
}

export const CAN_NATIVE_DEFAULTS = {
  numberOfBits: DEFAULT_NUM_BITS.NATIVE_OUTPUT_CAN_INPUT,
  operator: OPERATORS.EQUAL,
  value: EVAL_VALUES.TRUE,
  parentQueryUri: '',
  subType: CAN_INPUT,
  description: CAN_INPUT,
}

export const CAN_NATIVE_BOOL_DEFAULTS = {
  numberOfBits: DEFAULT_NUM_BITS.SINGLE_CONDITION,
  operator: OPERATORS.EQUAL,
  value: EVAL_VALUES.TRUE,
  parentQueryUri: '',
  subType: CAN_INPUT,
  description: CAN_INPUT,
}

export const NATIVE_SINGLE_DEFAULTS = {
  operator: OPERATORS.EQUAL,
  value: DEFAULT_VALUE,
  description: NATIVE_INPUT,
  parentQueryUri: '',
  subType: NATIVE_INPUT,
}

export const NATIVE_SIXTEEN_DEFAULTS = {
  subType: NATIVE_INPUT,
  description: NATIVE_INPUT,
}

export const SWITCH_SINGLE_DEFAULTS = {
  operator: OPERATORS.EQUAL,
  value: DEFAULT_VALUE,
  description: SWITCH_INPUT,
  parentQueryUri: '',
  subType: SWITCH_INPUT,
}

export const SWITCH_SIXTEEN_DEFAULTS = {
  subType: SWITCH_INPUT,
  description: SWITCH_INPUT,
}

export const ANALOG_SINGLE_DEFAULTS = {
  operator: OPERATORS.EQUAL,
  value: DEFAULT_VALUE,
  description: strings.analog_input_pin,
  parentQueryUri: '',
  subType: ANALOG_INPUT,
}

export const ANALOG_SIXTEEN_DEFAULTS = {
  subType: ANALOG_INPUT,
  description: strings.analog_input_pin,
}

export const DIGITAL_SINGLE_DEFAULTS = {
  operator: OPERATORS.EQUAL,
  value: DEFAULT_VALUE,
  description: DIGITAL_INPUT,
  parentQueryUri: '',
  subType: DIGITAL_INPUT,
}

export const DIGITAL_NATIVE_OUTPUT_DEFAULTS = {
  operator: OPERATORS.EQUAL,
  value: DEFAULT_VALUE,
  description: DIGITAL_INPUT,
  parentQueryUri: '',
  subType: DIGITAL_INPUT,
  inputConfig: ACTIVE_HIGH,
}

export const OPERATORS_REQUIRING_HYSTERESIS = new Set([
  OPERATORS.LESS_THAN,
  OPERATORS.GREATER_THAN_OR_EQUAL,
])
